/* global process */

import { Text } from 'pixi.js'
import { FT, Scene, ResManager, Sprite } from 'ft'
import store from '../store'
import hooks from '../hooks'

const $bg = 'preloader-bg'
const $logo = 'preloader-logo'
const $customFont = 'custom-font'

class Preloader extends Scene {
  constructor(name) {
    super(name)
    this.preload()

    this.loadError = false
    hooks.enter = this.nextScene
  }

  preload() {
    const prm = new ResManager()
    this.prm = prm
    prm.on('complete', this.onPreloadDone)
    prm.addImage($bg)
    prm.addImage($logo)
    prm.addFont($customFont)
    prm.load()
  }

  onPreloadDone = () => {
    const { prm } = this
    const bg = new Sprite(prm.texture($bg))
    this.addChild(bg)

    const logo = new Sprite(prm.texture($logo))
    logo.anchor.set(0.5, 1)
    logo.x = FT.stage.centerX
    logo.y = FT.stage.centerY + 20
    this.addChild(logo)

    const progressText = new Text('... 0% ...', {
      fontFamily: 'custom-font',
      fontSize: 42,
      fill: 0x5a8bbb,
      align: 'center',
    })
    this.progressText = progressText
    progressText.anchor.set(0.5)
    progressText.x = FT.stage.centerX
    progressText.y = FT.stage.centerY + 60
    this.addChild(progressText)

    const { rm } = FT

    rm.addImage('share-button-next')
    rm.addImage('share-dialog-warm')
    rm.addImage('share-dialog-cold')
    rm.addSound('sound.bgm-intro')
    rm.addSound('sound.bgm-bedroom')
    rm.addSound('sound.env')

    rm.on('progress', ({ progress }) => {
      if (this.loadError) return

      this.progressText.text = `... ${progress.toFixed(0)}% ...`
    })
    rm.on('complete', this.onResLoaded)
    rm.on('error', this.onResError)
    rm.load()
  }

  onResError = async () => {
    this.loadError = true

    this.progressText.text = '资源加载失败，请刷新重试'
  }

  onResLoaded = async () => {
    if (this.loadError) return

    FT.backgroundColor = 'rgba(0, 0, 0, 1)'

    this.interactive = true
    this.on('pointerup', () => {
      hooks.onTouchPreloader()
    })

    hooks.onResourceLoaded()

    if (process.env.WCP_PREVIEW) {
      this.progressText.text = '点击进入冰雪世界'

      this.interactive = true
      this.on('pointerup', this.nextScene)
    } else {
      this.progressText.text = '欢迎来到冰雪世界'
    }
  }

  nextScene = () => {
    if (process.env.WCP_PREVIEW) {
      const query = location.search.replace('?', '')
      if (query === 'old-user') {
        store.username = '大脚怪'
        store.type = 'old-user'
        store.quilt = 2
        store.hero = 'slk'
        store.level = 7
        store.temp = 25
        store.friends = [
          { name: '大哥', temp: 5 },
          { name: '小弟', temp: 10 },
          { name: '苹果香蕉', temp: -5 },
          { name: '大哥', temp: 5 },
          { name: '小弟', temp: 10 },
          { name: '苹果香蕉大脚挂俄土豪土豪土豪它', temp: -5 },
          { name: 'bililiitih tehiethtuetuheueue', temp: -5 },
          { name: '大哥', temp: 5 },
          { name: '小弟', temp: 10 },
          { name: '苹果香蕉', temp: -5 },
          { name: '大哥', temp: 5 },
          { name: '小弟', temp: 10 },
          { name: '苹果香蕉', temp: -5 },
        ]
        store.isRewarded = false
      }

      if (query === 'old-user-rewarded') {
        store.username = '呼噜噜'
        store.type = 'old-user'
        store.quilt = 3
        store.hero = 'slk'
        store.level = 3
        store.temp = 40
        store.prize = {
          url: 'https://game.gtimg.cn/images/lol/appskin/131001.jpg',
          name: '暗黑女武神 黛安娜(7天）',
        }

        store.friends = [
          { name: '小冰', temp: 5 },
          { name: '英桥', temp: 10 },
          { name: '无所谓', temp: -5 },
          { name: '长江水', temp: -5 },
          { name: '大一统', temp: -5 },
          { name: '蛙蛙还活着', temp: 10 },
          { name: '大脚怪', temp: 10 },
        ]
        store.isRewarded = true
      }

      if (query === 'friend-zero') {
        store.username = '嘎嘎噜噜'
        store.type = 'friend'
        store.quilt = 2
        store.hero = 'yi'
        store.level = 3
        store.friends = []
        store.isRewarded = false
      }

      if (query === 'friend-five') {
        store.username = '嘀嘀噜噜'
        store.type = 'friend'
        store.quilt = 2
        store.hero = 'md'
        store.level = 3
        store.temp = 25
        store.friends = [
          { name: '英桥', temp: 10 },
          { name: '无所谓', temp: -5 },
          { name: '长江水', temp: -5 },
          { name: '大一统', temp: -5 },
          { name: '蛙蛙还活着', temp: 10 },
        ]
        store.isRewarded = false
      }

      if (query === 'no-level') {
        store.username = '嘎嘎噜噜'
        store.type = 'friend'
        store.quilt = 2
        store.hero = 'yi'
        store.level = 0
        store.friends = []
        store.isRewarded = false
      }

      if (query === 'no-level-rewarded') {
        store.username = '嘎嘎噜噜'
        store.type = 'old-user'
        store.quilt = 2
        store.hero = 'akl'
        store.level = 0
        store.prize = 1
        store.friends = [
          { name: '英桥', temp: 10 },
          { name: '无所谓', temp: -5 },
          { name: '长江水', temp: -5 },
          { name: '大一统', temp: -5 },
          { name: '蛙蛙还活着', temp: 10 },
        ]
        store.isRewarded = true
      }
    }

    const sceneName = store.type === 'new-user' ? 'intro' : 'bed'
    FT.sm.load(sceneName)
  }
}

export default Preloader
